exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3TLA02Slt3cIjgVuTK_WcC{font-family:Lemonada, cursive;font-size:14px;text-align:justify;text-justify:auto;line-height:32px;color:#262228}.vW6YJcoKn-7AEw3862kvO{font-size:11px;font-family:Lemonada, cursive;color:#666;padding-top:20px}\n", ""]);
// Exports
exports.locals = {
	"intro": "_3TLA02Slt3cIjgVuTK_WcC",
	"careerLink": "vW6YJcoKn-7AEw3862kvO"
};